import Component from '@bythepixel/component-loader';

export default class YoutubeFacetedSearch extends Component {
  static selector = '[data-comp-youtube-faceted-search]';
  static loaderPriority = 'in-view';

  constructor(element) {
    super(element);

    this.mount();
  }

  attachListeners() {
    window.addEventListener('livewire:pagination-clicked', () => this.$container.scrollIntoView());
  }

  mount() {
    this.attachListeners();
  }
}
